const CountryModule = {
  namespaced: true,
  state() {
    return {
      contryList: [
        {
          CountryCode: 218,
          Country: "Afghanistan",
        },
        {
          CountryCode: 219,
          Country: "Albania",
        },
        {
          CountryCode: 220,
          Country: "Algeria",
        },
        {
          CountryCode: 221,
          Country: "American Samoa",
        },
        {
          CountryCode: 222,
          Country: "Andorra",
        },
        {
          CountryCode: 223,
          Country: "Angola",
        },
        {
          CountryCode: 224,
          Country: "Antigua & Barbuda",
        },
        {
          CountryCode: 225,
          Country: "Argentina",
        },
        {
          CountryCode: 226,
          Country: "Armenia",
        },
        {
          CountryCode: 227,
          Country: "Aruba",
        },
        {
          CountryCode: 228,
          Country: "Ascension Island",
        },
        {
          CountryCode: 229,
          Country: "Australia",
        },
        {
          CountryCode: 230,
          Country: "Austria",
        },
        {
          CountryCode: 231,
          Country: "Azerbaijan",
        },
        {
          CountryCode: 232,
          Country: "Bahamas",
        },
        {
          CountryCode: 233,
          Country: "Bahrain",
        },
        {
          CountryCode: 234,
          Country: "Bangladesh",
        },
        {
          CountryCode: 235,
          Country: "Barbados",
        },
        {
          CountryCode: 236,
          Country: "Belarus",
        },
        {
          CountryCode: 237,
          Country: "Belgium",
        },
        {
          CountryCode: 238,
          Country: "Belize",
        },
        {
          CountryCode: 239,
          Country: "Benin",
        },
        {
          CountryCode: 240,
          Country: "Bermuda",
        },
        {
          CountryCode: 241,
          Country: "Bhutan",
        },
        {
          CountryCode: 242,
          Country: "Bolivia",
        },
        {
          CountryCode: 243,
          Country: "Bosnia & Herzegovina",
        },
        {
          CountryCode: 244,
          Country: "Botswana",
        },
        {
          CountryCode: 245,
          Country: "Brazil",
        },
        {
          CountryCode: 246,
          Country: "British West Indies",
        },
        {
          CountryCode: 247,
          Country: "Brunei",
        },
        {
          CountryCode: 248,
          Country: "Bulgaria",
        },
        {
          CountryCode: 249,
          Country: "Burkina Faso",
        },
        {
          CountryCode: 250,
          Country: "Burundi",
        },
        {
          CountryCode: 251,
          Country: "Cambodia",
        },
        {
          CountryCode: 252,
          Country: "Cameroon",
        },
        {
          CountryCode: 253,
          Country: "Canada",
        },
        {
          CountryCode: 254,
          Country: "Cape Verde",
        },
        {
          CountryCode: 255,
          Country: "Cayman Islands",
        },
        {
          CountryCode: 256,
          Country: "Central African Republic",
        },
        {
          CountryCode: 257,
          Country: "Chad",
        },
        {
          CountryCode: 258,
          Country: "Chile",
        },
        {
          CountryCode: 259,
          Country: "China",
        },
        {
          CountryCode: 260,
          Country: "Colombia",
        },
        {
          CountryCode: 261,
          Country: "Commonwealth Dominica",
        },
        {
          CountryCode: 262,
          Country: "Comoros",
        },
        {
          CountryCode: 263,
          Country: "Congo",
        },
        {
          CountryCode: 264,
          Country: "Costa Rica",
        },
        {
          CountryCode: 265,
          Country: "Cote d'lovire",
        },
        {
          CountryCode: 266,
          Country: "Croatia",
        },
        {
          CountryCode: 267,
          Country: "Cuba",
        },
        {
          CountryCode: 268,
          Country: "Cyprus",
        },
        {
          CountryCode: 269,
          Country: "Czech Republic",
        },
        {
          CountryCode: 270,
          Country: "Denmark",
        },
        {
          CountryCode: 271,
          Country: "Djibouti",
        },
        {
          CountryCode: 272,
          Country: "Dominica",
        },
        {
          CountryCode: 273,
          Country: "Dominican Republic",
        },
        {
          CountryCode: 274,
          Country: "E.C.U.",
        },
        {
          CountryCode: 275,
          Country: "Ecuador",
        },
        {
          CountryCode: 276,
          Country: "Egypt",
        },
        {
          CountryCode: 277,
          Country: "El Salvador",
        },
        {
          CountryCode: 278,
          Country: "Equatorial Guinea",
        },
        {
          CountryCode: 279,
          Country: "Eritrea",
        },
        {
          CountryCode: 280,
          Country: "Estonia",
        },
        {
          CountryCode: 281,
          Country: "Ethiopia",
        },
        {
          CountryCode: 282,
          Country: "Fiji",
        },
        {
          CountryCode: 283,
          Country: "Finland",
        },
        {
          CountryCode: 284,
          Country: "France",
        },
        {
          CountryCode: 285,
          Country: "French Antilles",
        },
        {
          CountryCode: 286,
          Country: "French Guiana",
        },
        {
          CountryCode: 287,
          Country: "French Polynesia",
        },
        {
          CountryCode: 288,
          Country: "Gabon",
        },
        {
          CountryCode: 289,
          Country: "Gambia",
        },
        {
          CountryCode: 290,
          Country: "Georgia",
        },
        {
          CountryCode: 291,
          Country: "Germany",
        },
        {
          CountryCode: 292,
          Country: "Ghana",
        },
        {
          CountryCode: 293,
          Country: "Gibraltar",
        },
        {
          CountryCode: 294,
          Country: "Grand Cayman",
        },
        {
          CountryCode: 295,
          Country: "Greece",
        },
        {
          CountryCode: 296,
          Country: "Grenada",
        },
        {
          CountryCode: 297,
          Country: "Guam",
        },
        {
          CountryCode: 298,
          Country: "Guantanamo Bay",
        },
        {
          CountryCode: 299,
          Country: "Guatemala",
        },
        {
          CountryCode: 300,
          Country: "Guinea",
        },
        {
          CountryCode: 301,
          Country: "Guinea-Bissau",
        },
        {
          CountryCode: 302,
          Country: "Guyana",
        },
        {
          CountryCode: 303,
          Country: "Haiti",
        },
        {
          CountryCode: 304,
          Country: "Honduras",
        },
        {
          CountryCode: 305,
          Country: "Hong Kong",
        },
        {
          CountryCode: 306,
          Country: "Hungary",
        },
        {
          CountryCode: 307,
          Country: "Iceland",
        },
        {
          CountryCode: 308,
          Country: "India",
        },
        {
          CountryCode: 309,
          Country: "Indonesia",
        },
        {
          CountryCode: 310,
          Country: "Iran",
        },
        {
          CountryCode: 311,
          Country: "Iraq",
        },
        {
          CountryCode: 312,
          Country: "Ireland",
        },
        {
          CountryCode: 313,
          Country: "Israel",
        },
        {
          CountryCode: 314,
          Country: "Italy",
        },
        {
          CountryCode: 315,
          Country: "Ivory Coast",
        },
        {
          CountryCode: 316,
          Country: "Jamaica",
        },
        {
          CountryCode: 317,
          Country: "Japan",
        },
        {
          CountryCode: 318,
          Country: "Jordan",
        },
        {
          CountryCode: 319,
          Country: "Kazakhstan",
        },
        {
          CountryCode: 320,
          Country: "Kenya",
        },
        {
          CountryCode: 321,
          Country: "Kiribati",
        },
        {
          CountryCode: 322,
          Country: "Kuwait",
        },
        {
          CountryCode: 323,
          Country: "Kyrgyzstan",
        },
        {
          CountryCode: 324,
          Country: "Laos",
        },
        {
          CountryCode: 325,
          Country: "Latvia",
        },
        {
          CountryCode: 326,
          Country: "Lebanon",
        },
        {
          CountryCode: 327,
          Country: "Lesotho",
        },
        {
          CountryCode: 328,
          Country: "Liberia",
        },
        {
          CountryCode: 329,
          Country: "Libya",
        },
        {
          CountryCode: 330,
          Country: "Liechtenstein",
        },
        {
          CountryCode: 331,
          Country: "Lithuania",
        },
        {
          CountryCode: 332,
          Country: "Luxembourg",
        },
        {
          CountryCode: 333,
          Country: "Macao",
        },
        {
          CountryCode: 334,
          Country: "Macedonia",
        },
        {
          CountryCode: 335,
          Country: "Madagascar",
        },
        {
          CountryCode: 336,
          Country: "Malawi",
        },
        {
          CountryCode: 337,
          Country: "Malaysia",
        },
        {
          CountryCode: 338,
          Country: "Maldives",
        },
        {
          CountryCode: 339,
          Country: "Mali",
        },
        {
          CountryCode: 340,
          Country: "Malta",
        },
        {
          CountryCode: 341,
          Country: "Marshall Islands",
        },
        {
          CountryCode: 342,
          Country: "Mauritania",
        },
        {
          CountryCode: 343,
          Country: "Mauritius",
        },
        {
          CountryCode: 344,
          Country: "Mexico",
        },
        {
          CountryCode: 345,
          Country: "Micronesia",
        },
        {
          CountryCode: 346,
          Country: "Moldova",
        },
        {
          CountryCode: 347,
          Country: "Monaco",
        },
        {
          CountryCode: 348,
          Country: "Mongolia",
        },
        {
          CountryCode: 349,
          Country: "Morocco",
        },
        {
          CountryCode: 350,
          Country: "Mozambique",
        },
        {
          CountryCode: 351,
          Country: "Myanmar",
        },
        {
          CountryCode: 352,
          Country: "Namibia",
        },
        {
          CountryCode: 353,
          Country: "Naura",
        },
        {
          CountryCode: 354,
          Country: "Nepal",
        },
        {
          CountryCode: 355,
          Country: "Netherlands",
        },
        {
          CountryCode: 356,
          Country: "Netherlands Antilles",
        },
        {
          CountryCode: 357,
          Country: "New Caledonia",
        },
        {
          CountryCode: 358,
          Country: "New Guinea",
        },
        {
          CountryCode: 359,
          Country: "New Zealand",
        },
        {
          CountryCode: 360,
          Country: "Nicaragua",
        },
        {
          CountryCode: 361,
          Country: "Niger",
        },
        {
          CountryCode: 362,
          Country: "Nigeria",
        },
        {
          CountryCode: 363,
          Country: "North Korea",
        },
        {
          CountryCode: 364,
          Country: "Norway",
        },
        {
          CountryCode: 365,
          Country: "Oman",
        },
        {
          CountryCode: 366,
          Country: "Pakistan",
        },
        {
          CountryCode: 367,
          Country: "Palau",
        },
        {
          CountryCode: 368,
          Country: "Panama",
        },
        {
          CountryCode: 369,
          Country: "Papua New Guinea",
        },
        {
          CountryCode: 370,
          Country: "Paraguay",
        },
        {
          CountryCode: 371,
          Country: "Peru",
        },
        {
          CountryCode: 372,
          Country: "Philippines",
        },
        {
          CountryCode: 373,
          Country: "Poland",
        },
        {
          CountryCode: 374,
          Country: "Portugal",
        },
        {
          CountryCode: 375,
          Country: "Puerto Rico",
        },
        {
          CountryCode: 376,
          Country: "Qatar",
        },
        {
          CountryCode: 377,
          Country: "Romania",
        },
        {
          CountryCode: 378,
          Country: "Russia",
        },
        {
          CountryCode: 379,
          Country: "Rwanda",
        },
        {
          CountryCode: 380,
          Country: "Saipan",
        },
        {
          CountryCode: 381,
          Country: "San Marino",
        },
        {
          CountryCode: 382,
          Country: "Sao Tome & Principe",
        },
        {
          CountryCode: 383,
          Country: "Saudi Arabia",
        },
        {
          CountryCode: 384,
          Country: "Scotland",
        },
        {
          CountryCode: 385,
          Country: "Senegal",
        },
        {
          CountryCode: 386,
          Country: "Seychelles",
        },
        {
          CountryCode: 387,
          Country: "Sierra Leone",
        },
        {
          CountryCode: 388,
          Country: "Singapore",
        },
        {
          CountryCode: 389,
          Country: "Slovakia",
        },
        {
          CountryCode: 390,
          Country: "Slovenia",
        },
        {
          CountryCode: 391,
          Country: "Solomon Islands",
        },
        {
          CountryCode: 392,
          Country: "Somalia",
        },
        {
          CountryCode: 393,
          Country: "South Africa",
        },
        {
          CountryCode: 394,
          Country: "South Korea",
        },
        {
          CountryCode: 395,
          Country: "Spain",
        },
        {
          CountryCode: 396,
          Country: "Sri Lanka",
        },
        {
          CountryCode: 397,
          Country: "St. Kitts & Nevis",
        },
        {
          CountryCode: 398,
          Country: "St. Lucia",
        },
        {
          CountryCode: 399,
          Country: "St. Pierre & Miquelon",
        },
        {
          CountryCode: 400,
          Country: "St. Vincent & Grenadine",
        },
        {
          CountryCode: 401,
          Country: "Sudan",
        },
        {
          CountryCode: 402,
          Country: "Suriname",
        },
        {
          CountryCode: 403,
          Country: "Swaziland",
        },
        {
          CountryCode: 404,
          Country: "Sweden",
        },
        {
          CountryCode: 405,
          Country: "Switzerland",
        },
        {
          CountryCode: 406,
          Country: "Syria",
        },
        {
          CountryCode: 407,
          Country: "Taiwan",
        },
        {
          CountryCode: 408,
          Country: "Tajikistan",
        },
        {
          CountryCode: 409,
          Country: "Tanzania",
        },
        {
          CountryCode: 410,
          Country: "Thailand",
        },
        {
          CountryCode: 411,
          Country: "Togo",
        },
        {
          CountryCode: 412,
          Country: "Tonga",
        },
        {
          CountryCode: 413,
          Country: "Trinidad",
        },
        {
          CountryCode: 414,
          Country: "Tunisia",
        },
        {
          CountryCode: 415,
          Country: "Turkey",
        },
        {
          CountryCode: 416,
          Country: "Tuvalu",
        },
        {
          CountryCode: 417,
          Country: "USA",
        },
        {
          CountryCode: 418,
          Country: "Uganda",
        },
        {
          CountryCode: 419,
          Country: "Ukraine",
        },
        {
          CountryCode: 420,
          Country: "United Arab Emirates",
        },
        {
          CountryCode: 421,
          Country: "United Kingdom",
        },
        {
          CountryCode: 422,
          Country: "Uruguay",
        },
        {
          CountryCode: 423,
          Country: "Uzbekistan",
        },
        {
          CountryCode: 424,
          Country: "Vanuatu",
        },
        {
          CountryCode: 425,
          Country: "Vatican City",
        },
        {
          CountryCode: 426,
          Country: "Venezuela",
        },
        {
          CountryCode: 427,
          Country: "Vietnam",
        },
        {
          CountryCode: 428,
          Country: "Virgin Islands",
        },
        {
          CountryCode: 429,
          Country: "Western Samoa",
        },
        {
          CountryCode: 430,
          Country: "Yemen Arab Republic",
        },
        {
          CountryCode: 431,
          Country: "Yugoslavia",
        },
        {
          CountryCode: 432,
          Country: "Zaire",
        },
        {
          CountryCode: 433,
          Country: "Zambia",
        },
        {
          CountryCode: 434,
          Country: "Zimbabwe",
        },
      ],

      stripeCountryList: [
        { CountryCode: "AD", Country: "Andorra" },
        { CountryCode: "AE", Country: "United Arab Emirates" },
        { CountryCode: "AF", Country: "Afghanistan" },
        { CountryCode: "AG", Country: "Antigua and Barbuda" },
        { CountryCode: "AI", Country: "Anguilla" },
        { CountryCode: "AL", Country: "Albania" },
        { CountryCode: "AM", Country: "Armenia" },
        { CountryCode: "AO", Country: "Angola" },
        { CountryCode: "AQ", Country: "Antarctica" },
        { CountryCode: "AR", Country: "Argentina" },
        { CountryCode: "AS", Country: "American Samoa" },
        { CountryCode: "AT", Country: "Austria" },
        { CountryCode: "AU", Country: "Australia" },
        { CountryCode: "AW", Country: "Aruba" },
        { CountryCode: "AX", Country: "Åland Islands" },
        { CountryCode: "AZ", Country: "Azerbaijan" },
        { CountryCode: "BA", Country: "Bosnia and Herzegovina" },
        { CountryCode: "BB", Country: "Barbados" },
        { CountryCode: "BD", Country: "Bangladesh" },
        { CountryCode: "BE", Country: "Belgium" },
        { CountryCode: "BF", Country: "Burkina Faso" },
        { CountryCode: "BG", Country: "Bulgaria" },
        { CountryCode: "BH", Country: "Bahrain" },
        { CountryCode: "BI", Country: "Burundi" },
        { CountryCode: "BJ", Country: "Benin" },
        { CountryCode: "BL", Country: "Saint Barthélemy" },
        { CountryCode: "BM", Country: "Bermuda" },
        { CountryCode: "BN", Country: "Brunei Darussalam" },
        { CountryCode: "BO", Country: "Bolivia, Plurinational State of" },
        { CountryCode: "BQ", Country: "Bonaire, Sint Eustatius and Saba" },
        { CountryCode: "BR", Country: "Brazil" },
        { CountryCode: "BS", Country: "Bahamas" },
        { CountryCode: "BT", Country: "Bhutan" },
        { CountryCode: "BV", Country: "Bouvet Island" },
        { CountryCode: "BW", Country: "Botswana" },
        { CountryCode: "BY", Country: "Belarus" },
        { CountryCode: "BZ", Country: "Belize" },
        { CountryCode: "CA", Country: "Canada" },
        { CountryCode: "CC", Country: "Cocos (Keeling) Islands" },
        { CountryCode: "CD", Country: "Congo, Democratic Republic of the" },
        { CountryCode: "CF", Country: "Central African Republic" },
        { CountryCode: "CG", Country: "Congo" },
        { CountryCode: "CH", Country: "Switzerland" },
        { CountryCode: "CI", Country: "Côte d'Ivoire" },
        { CountryCode: "CK", Country: "Cook Islands" },
        { CountryCode: "CL", Country: "Chile" },
        { CountryCode: "CM", Country: "Cameroon" },
        { CountryCode: "CN", Country: "China" },
        { CountryCode: "CO", Country: "Colombia" },
        { CountryCode: "CR", Country: "Costa Rica" },
        { CountryCode: "CU", Country: "Cuba" },
        { CountryCode: "CV", Country: "Cabo Verde" },
        { CountryCode: "CW", Country: "Curaçao" },
        { CountryCode: "CX", Country: "Christmas Island" },
        { CountryCode: "CY", Country: "Cyprus" },
        { CountryCode: "CZ", Country: "Czechia" },
        { CountryCode: "DE", Country: "Germany" },
        { CountryCode: "DJ", Country: "Djibouti" },
        { CountryCode: "DK", Country: "Denmark" },
        { CountryCode: "DM", Country: "Dominica" },
        { CountryCode: "DO", Country: "Dominican Republic" },
        { CountryCode: "DZ", Country: "Algeria" },
        { CountryCode: "EC", Country: "Ecuador" },
        { CountryCode: "EE", Country: "Estonia" },
        { CountryCode: "EG", Country: "Egypt" },
        { CountryCode: "EH", Country: "Western Sahara" },
        { CountryCode: "ER", Country: "Eritrea" },
        { CountryCode: "ES", Country: "Spain" },
        { CountryCode: "ET", Country: "Ethiopia" },
        { CountryCode: "FI", Country: "Finland" },
        { CountryCode: "FJ", Country: "Fiji" },
        { CountryCode: "FK", Country: "Falkland Islands (Malvinas)" },
        { CountryCode: "FM", Country: "Micronesia, Federated States of" },
        { CountryCode: "FO", Country: "Faroe Islands" },
        { CountryCode: "FR", Country: "France" },
        { CountryCode: "GA", Country: "Gabon" },
        { CountryCode: "GB", Country: "United Kingdom" },
        { CountryCode: "GD", Country: "Grenada" },
        { CountryCode: "GE", Country: "Georgia" },
        { CountryCode: "GF", Country: "French Guiana" },
        { CountryCode: "GG", Country: "Guernsey" },
        { CountryCode: "GH", Country: "Ghana" },
        { CountryCode: "GI", Country: "Gibraltar" },
        { CountryCode: "GL", Country: "Greenland" },
        { CountryCode: "GM", Country: "Gambia" },
        { CountryCode: "GN", Country: "Guinea" },
        { CountryCode: "GP", Country: "Guadeloupe" },
        { CountryCode: "GQ", Country: "Equatorial Guinea" },
        { CountryCode: "GR", Country: "Greece" },
        { CountryCode: "GS", Country: "South Georgia and the South Sandwich Islands" },
        { CountryCode: "GT", Country: "Guatemala" },
        { CountryCode: "GU", Country: "Guam" },
        { CountryCode: "GW", Country: "Guinea-Bissau" },
        { CountryCode: "GY", Country: "Guyana" },
        { CountryCode: "HK", Country: "Hong Kong" },
        { CountryCode: "HM", Country: "Heard Island and McDonald Islands" },
        { CountryCode: "HN", Country: "Honduras" },
        { CountryCode: "HR", Country: "Croatia" },
        { CountryCode: "HT", Country: "Haiti" },
        { CountryCode: "HU", Country: "Hungary" },
        { CountryCode: "ID", Country: "Indonesia" },
        { CountryCode: "IE", Country: "Ireland" },
        { CountryCode: "IL", Country: "Israel" },
        { CountryCode: "IM", Country: "Isle of Man" },
        { CountryCode: "IN", Country: "India" },
        { CountryCode: "IO", Country: "British Indian Ocean Territory" },
        { CountryCode: "IQ", Country: "Iraq" },
        { CountryCode: "IR", Country: "Iran, Islamic Republic of" },
        { CountryCode: "IS", Country: "Iceland" },
        { CountryCode: "IT", Country: "Italy" },
        { CountryCode: "JE", Country: "Jersey" },
        { CountryCode: "JM", Country: "Jamaica" },
        { CountryCode: "JO", Country: "Jordan" },
        { CountryCode: "JP", Country: "Japan" },
        { CountryCode: "KE", Country: "Kenya" },
        { CountryCode: "KG", Country: "Kyrgyzstan" },
        { CountryCode: "KH", Country: "Cambodia" },
        { CountryCode: "KI", Country: "Kiribati" },
        { CountryCode: "KM", Country: "Comoros" },
        { CountryCode: "KN", Country: "Saint Kitts and Nevis" },
        { CountryCode: "KP", Country: "Korea, Democratic People's Republic of" },
        { CountryCode: "KR", Country: "Korea, Republic of" },
        { CountryCode: "KW", Country: "Kuwait" },
        { CountryCode: "KY", Country: "Cayman Islands" },
        { CountryCode: "KZ", Country: "Kazakhstan" },
        { CountryCode: "LA", Country: "Lao People's Democratic Republic" },
        { CountryCode: "LB", Country: "Lebanon" },
        { CountryCode: "LC", Country: "Saint Lucia" },
        { CountryCode: "LI", Country: "Liechtenstein" },
        { CountryCode: "LK", Country: "Sri Lanka" },
        { CountryCode: "LR", Country: "Liberia" },
        { CountryCode: "LS", Country: "Lesotho" },
        { CountryCode: "LT", Country: "Lithuania" },
        { CountryCode: "LU", Country: "Luxembourg" },
        { CountryCode: "LV", Country: "Latvia" },
        { CountryCode: "LY", Country: "Libya" },
        { CountryCode: "MA", Country: "Morocco" },
        { CountryCode: "MC", Country: "Monaco" },
        { CountryCode: "MD", Country: "Moldova, Republic of" },
        { CountryCode: "ME", Country: "Montenegro" },
        { CountryCode: "MF", Country: "Saint Martin (French part)" },
        { CountryCode: "MG", Country: "Madagascar" },
        { CountryCode: "MH", Country: "Marshall Islands" },
        { CountryCode: "MK", Country: "North Macedonia" },
        { CountryCode: "ML", Country: "Mali" },
        { CountryCode: "MM", Country: "Myanmar" },
        { CountryCode: "MN", Country: "Mongolia" },
        { CountryCode: "MO", Country: "Macao" },
        { CountryCode: "MP", Country: "Northern Mariana Islands" },
        { CountryCode: "MQ", Country: "Martinique" },
        { CountryCode: "MR", Country: "Mauritania" },
        { CountryCode: "MS", Country: "Montserrat" },
        { CountryCode: "MT", Country: "Malta" },
        { CountryCode: "MU", Country: "Mauritius" },
        { CountryCode: "MV", Country: "Maldives" },
        { CountryCode: "MW", Country: "Malawi" },
        { CountryCode: "MX", Country: "Mexico" },
        { CountryCode: "MY", Country: "Malaysia" },
        { CountryCode: "MZ", Country: "Mozambique" },
        { CountryCode: "NA", Country: "Namibia" },
        { CountryCode: "NC", Country: "New Caledonia" },
        { CountryCode: "NE", Country: "Niger" },
  { CountryCode: "NF", Country: "Norfolk Island" },
  { CountryCode: "NG", Country: "Nigeria" },
  { CountryCode: "NI", Country: "Nicaragua" },
  { CountryCode: "NL", Country: "Netherlands" },
  { CountryCode: "NO", Country: "Norway" },
  { CountryCode: "NP", Country: "Nepal" },
  { CountryCode: "NR", Country: "Nauru" },
  { CountryCode: "NU", Country: "Niue" },
  { CountryCode: "NZ", Country: "New Zealand" },
  { CountryCode: "OM", Country: "Oman" },
  { CountryCode: "PA", Country: "Panama" },
  { CountryCode: "PE", Country: "Peru" },
  { CountryCode: "PF", Country: "French Polynesia" },
  { CountryCode: "PG", Country: "Papua New Guinea" },
  { CountryCode: "PH", Country: "Philippines" },
  { CountryCode: "PK", Country: "Pakistan" },
  { CountryCode: "PL", Country: "Poland" },
  { CountryCode: "PM", Country: "Saint Pierre and Miquelon" },
  { CountryCode: "PN", Country: "Pitcairn Islands" },
  { CountryCode: "PR", Country: "Puerto Rico" },
  { CountryCode: "PT", Country: "Portugal" },
  { CountryCode: "PW", Country: "Palau" },
  { CountryCode: "PY", Country: "Paraguay" },
  { CountryCode: "QA", Country: "Qatar" },
  { CountryCode: "RE", Country: "Réunion" },
  { CountryCode: "RO", Country: "Romania" },
  { CountryCode: "RS", Country: "Serbia" },
  { CountryCode: "RU", Country: "Russian Federation" },
  { CountryCode: "RW", Country: "Rwanda" },
  { CountryCode: "SA", Country: "Saudi Arabia" },
  { CountryCode: "SB", Country: "Solomon Islands" },
  { CountryCode: "SC", Country: "Seychelles" },
  { CountryCode: "SD", Country: "Sudan" },
  { CountryCode: "SE", Country: "Sweden" },
  { CountryCode: "SG", Country: "Singapore" },
  { CountryCode: "SH", Country: "Saint Helena, Ascension and Tristan da Cunha" },
  { CountryCode: "SI", Country: "Slovenia" },
  { CountryCode: "SJ", Country: "Svalbard and Jan Mayen" },
  { CountryCode: "SK", Country: "Slovakia" },
  { CountryCode: "SL", Country: "Sierra Leone" },
  { CountryCode: "SM", Country: "San Marino" },
  { CountryCode: "SN", Country: "Senegal" },
  { CountryCode: "SO", Country: "Somalia" },
  { CountryCode: "SR", Country: "Suriname" },
  { CountryCode: "SS", Country: "South Sudan" },
  { CountryCode: "ST", Country: "Sao Tome and Principe" },
  { CountryCode: "SV", Country: "El Salvador" },
  { CountryCode: "SX", Country: "Sint Maarten" },
  { CountryCode: "SY", Country: "Syrian Arab Republic" },
  { CountryCode: "SZ", Country: "Eswatini" },
  { CountryCode: "TC", Country: "Turks and Caicos Islands" },
  { CountryCode: "TD", Country: "Chad" },
  { CountryCode: "TF", Country: "French Southern Territories" },
  { CountryCode: "TG", Country: "Togo" },
  { CountryCode: "TH", Country: "Thailand" },
  { CountryCode: "TJ", Country: "Tajikistan" },
  { CountryCode: "TK", Country: "Tokelau" },
  { CountryCode: "TL", Country: "Timor-Leste" },
  { CountryCode: "TM", Country: "Turkmenistan" },
  { CountryCode: "TN", Country: "Tunisia" },
  { CountryCode: "TO", Country: "Tonga" },
  { CountryCode: "TR", Country: "Turkey" },
  { CountryCode: "TT", Country: "Trinidad & Tobago" },
  { CountryCode: "TV", Country: "Tuvalu" },
  { CountryCode: "TZ", Country: "Tanzania" },
  { CountryCode: "UA", Country: "Ukraine" },
  { CountryCode: "UG", Country: "Uganda" },
  { CountryCode: "US", Country: "United States" },
  { CountryCode: "UY", Country: "Uruguay" },
  { CountryCode: "UZ", Country: "Uzbekistan" },
  { CountryCode: "VA", Country: "Holy See" },
  { CountryCode: "VC", Country: "Saint Vincent and the Grenadines" },
  { CountryCode: "VE", Country: "Venezuela (Bolivarian Republic of)" },
  { CountryCode: "VG", Country: "Virgin Islands (British)" },
  { CountryCode: "VI", Country: "Virgin Islands (U.S.)" },
  { CountryCode: "VN", Country: "Viet Nam" },
  { CountryCode: "VU", Country: "Vanuatu" },
  { CountryCode: "WF", Country: "Wallis and Futuna" },
  { CountryCode: "WS", Country: "Samoa" },
  { CountryCode: "YE", Country: "Yemen" },
  { CountryCode: "YT", Country: "Mayotte" },
  { CountryCode: "ZA", Country: "South Africa" },
  { CountryCode: "ZM", Country: "Zambia" },
  { CountryCode: "ZW", Country: "Zimbabwe" }
      ],


      USAstateslist: [
        {
          StateAbbr: "AA",
          StateName: "AA",
        },
        {
          StateAbbr: "AE",
          StateName: "AE",
        },
        {
          StateAbbr: "AP",
          StateName: "AP",
        },
        {
          StateAbbr: "AL",
          StateName: "Alabama",
        },
        {
          StateAbbr: "AK",
          StateName: "Alaska",
        },
        {
          StateAbbr: "AZ",
          StateName: "Arizona",
        },
        {
          StateAbbr: "AR",
          StateName: "Arkansas",
        },
        {
          StateAbbr: "CA",
          StateName: "California",
        },
        {
          StateAbbr: "CO",
          StateName: "Colorado",
        },
        {
          StateAbbr: "CT",
          StateName: "Connecticut",
        },
        {
          StateAbbr: "DE",
          StateName: "Delaware",
        },
        {
          StateAbbr: "DC",
          StateName: "District Of Columbia",
        },
        {
          StateAbbr: "FL",
          StateName: "Florida",
        },
        {
          StateAbbr: "GA",
          StateName: "Georgia",
        },
        {
          StateAbbr: "GU",
          StateName: "Guam",
        },
        {
          StateAbbr: "HI",
          StateName: "Hawaii",
        },
        {
          StateAbbr: "ID",
          StateName: "Idaho",
        },
        {
          StateAbbr: "IL",
          StateName: "Illinois",
        },
        {
          StateAbbr: "IN",
          StateName: "Indiana",
        },
        {
          StateAbbr: "IA",
          StateName: "Iowa",
        },
        {
          StateAbbr: "KS",
          StateName: "Kansas",
        },
        {
          StateAbbr: "KY",
          StateName: "Kentucky",
        },
        {
          StateAbbr: "LA",
          StateName: "Louisiana",
        },
        {
          StateAbbr: "ME",
          StateName: "Maine",
        },
        {
          StateAbbr: "MH",
          StateName: "Marshall Islands",
        },
        {
          StateAbbr: "MD",
          StateName: "Maryland",
        },
        {
          StateAbbr: "MA",
          StateName: "Massachusetts",
        },
        {
          StateAbbr: "MI",
          StateName: "Michigan",
        },
        {
          StateAbbr: "MN",
          StateName: "Minnesota",
        },
        {
          StateAbbr: "MS",
          StateName: "Mississippi",
        },
        {
          StateAbbr: "MO",
          StateName: "Missouri",
        },
        {
          StateAbbr: "MT",
          StateName: "Montana",
        },
        {
          StateAbbr: "NE",
          StateName: "Nebraska",
        },
        {
          StateAbbr: "NV",
          StateName: "Nevada",
        },
        {
          StateAbbr: "NH",
          StateName: "New Hampshire",
        },
        {
          StateAbbr: "NJ",
          StateName: "New Jersey",
        },
        {
          StateAbbr: "NM",
          StateName: "New Mexico",
        },
        {
          StateAbbr: "NY",
          StateName: "New York",
        },
        {
          StateAbbr: "NC",
          StateName: "North Carolina",
        },
        {
          StateAbbr: "ND",
          StateName: "North Dakota",
        },
        {
          StateAbbr: "MP",
          StateName: "Northern Mariana Islands",
        },
        {
          StateAbbr: "OH",
          StateName: "Ohio",
        },
        {
          StateAbbr: "OK",
          StateName: "Oklahoma",
        },
        {
          StateAbbr: "OR",
          StateName: "Oregon",
        },
        {
          StateAbbr: "PA",
          StateName: "Pennsylvania",
        },
        {
          StateAbbr: "PR",
          StateName: "Puerto Rico",
        },
        {
          StateAbbr: "RI",
          StateName: "Rhode Island",
        },
        {
          StateAbbr: "SC",
          StateName: "South Carolina",
        },
        {
          StateAbbr: "SD",
          StateName: "South Dakota",
        },
        {
          StateAbbr: "TN",
          StateName: "Tennessee",
        },
        {
          StateAbbr: "TX",
          StateName: "Texas",
        },
        {
          StateAbbr: "UT",
          StateName: "Utah",
        },
        {
          StateAbbr: "VT",
          StateName: "Vermont",
        },
        {
          StateAbbr: "VI",
          StateName: "Virgin Islands",
        },
        {
          StateAbbr: "VA",
          StateName: "Virginia",
        },
        {
          StateAbbr: "WA",
          StateName: "Washington",
        },
        {
          StateAbbr: "WV",
          StateName: "West Virginia",
        },
        {
          StateAbbr: "WI",
          StateName: "Wisconsin",
        },
        {
          StateAbbr: "WY",
          StateName: "Wyoming",
        },
      ],
      Canadastateslist: [
        {
          StateName: "Alberta",
          StateAbbr: "AB",
        },
        {
          StateName: "British Columbia",
          StateAbbr: "BC",
        },
        {
          StateName: "Manitoba",
          StateAbbr: "MB",
        },
        {
          StateName: "New Brunswick",
          StateAbbr: "NB",
        },
        {
          StateName: "Newfoundland and Labrador",
          StateAbbr: "NF",
        },
        {
          StateName: "Northwest Territories",
          StateAbbr: "NT",
        },
        {
          StateName: "Nova Scotia",
          StateAbbr: "NS",
        },
        {
          StateName: "Nunavut",
          StateAbbr: "NU",
        },
        {
          StateName: "Ontario",
          StateAbbr: "ON",
        },
        {
          StateName: "Prince Edward Island",
          StateAbbr: "PE",
        },
        {
          StateName: "Quebec",
          StateAbbr: "QU",
        },
        {
          StateName: "Saskatchewan",
          StateAbbr: "SK",
        },
        {
          StateName: "Yukon",
          StateAbbr: "YT",
        },
      ],
       phoneType: [
        { 
            text: "Mobile Phone", 
            value: "Mobile" 
        },
        { 
            text: "Home Phone", 
            value: "Landline" 
        },
      ],
    };
  },
};
export default CountryModule;
